import React from "react";
import Flagship from "../../core/flagship";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import {
  Table,
  Loader,
  Label,
  Input,
  Icon,
  Menu,
  Button,
  Modal,
} from "semantic-ui-react";
import { throttle, empty } from "../../utils/helpers";
import FilterAssigneeModal from "../modals/FilterAssigneeModal";
import Filters from "../misc/Filters";
import moment from "moment-business-days";

class Campaigns extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.jumpToPage = this.jumpToPage.bind(this);
    this.filterSearch = this.filterSearch.bind(this);
    this.search = this.search.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.toggleFiltersVisibility = this.toggleFiltersVisibility.bind(this);
    this.onFilterToggle = this.onFilterToggle.bind(this);
    this.selectAllFilters = this.selectAllFilters.bind(this);
    this.selectAllInGroup = this.selectAllInGroup.bind(this);
    this.selectMultipleFilters = this.selectMultipleFilters.bind(this);
    this.saveData = this.saveData.bind(this);
    this.exportHeadings = [
      "Campaign Name",
      "Platform",
      "IO Product",
      "Client",
      "Market",
      "Assignee",
    ];
    this.timer = null;
  }

  getInitialState() {
    let filterStatus = this.props.location.query.status;
    let orderBy = this.props.location.query.orderby;

    let currentFilters = {};
    if (!empty(filterStatus)) {
      currentFilters.status = filterStatus;
    }
    if (!empty(orderBy)) {
      currentFilters.orderby = orderBy;
    }

    return {
      currentFilters,
      currentPage: 1,
      campaigns: [],
      totalCount: 0,
      totalPages: 1,
      loading: true,
      choosingAssignee: false,
      assigneeFilterName: null,
      filtersVisible: false,
      exportVisible: false,
      expandedFilters: false,
      exporting: false,
      exportProgress: 0
    };
  }

  componentWillMount() {
    // Call API
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / Registered Campaigns";
    this.getProducts();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.route.type !== this.props.route.type ||
      nextProps.instance !== this.props.instance
    ) {
      document.title = "Flagship / Registered Campaigns";
      this.setState(this.getInitialState(), this.getProducts);
    }
  }

  getProducts() {
    let self = this;

    let data = Object.assign(
      {
        instance: this.props.instance
      },
      this.state.currentFilters
    );

    Flagship.get(
      "campaigns/list/" + this.state.currentPage,
      data,
      function(response) {
        if (response.data.success === true) {
          self.setState({
            campaigns: response.data.results,
            totalCount: response.data.totalCount,
            totalPages: Math.ceil(response.data.totalCount / 15),
            loading: false
          });
        } else {
          Flagship.error("Error getting campaigns from Flagship API server.");
        }
      },
      function(err) {
        Flagship.error(
          "Error getting campaigns from Flagship API server: " + err
        );
      }
    );
  }

  prevPage() {
    this.setState(
      {
        currentPage:
          this.state.currentPage > 1
            ? this.state.currentPage - 1
            : this.state.currentPage
      },
      this.getProducts
    );
  }

  nextPage() {
    this.setState(
      {
        currentPage:
          this.state.currentPage < this.state.totalPages
            ? this.state.currentPage + 1
            : this.state.currentPage
      },
      this.getProducts
    );
  }

  jumpToPage(page) {
    this.setState(
      {
        currentPage: page,
        loading: true
      },
      this.getProducts
    );
  }

  filterSearch(value) {
    let currentFilters = Object.assign({}, this.state.currentFilters);

    if (value === "") {
      delete currentFilters["search"];
    } else {
      currentFilters["search"] = value;
    }

    this.setState({ currentFilters: currentFilters }, this.getProducts);
  }

  search(e) {
    e.persist();
    let filterSearch = this.filterSearch;
    this.timer = throttle(
      function() {
        filterSearch(e.target.value);
      },
      500,
      this.timer
    );
  }

  toggleFiltersVisibility() {
    this.setState({
      filtersVisible: !this.state.filtersVisible
    });
  }


  clearFilters(parameter = false) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (parameter) {
      // Only clear one filter group
      delete newFilters[parameter];
    } else {
      newFilters = [];
    }

    this.setState(
      {
        currentFilters: newFilters,
        exportStart: null,
        exportEnd: null
      },
      this.getProducts
    );
  }

  selectAllInGroup(key, possibleFilters) {
    let newFilters = [];

    if (Array.isArray(possibleFilters[key])) {
      possibleFilters[key].map(item => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    } else {
      Object.keys(possibleFilters[key]).map(item => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    }
    return newFilters;
  }

  selectAllFilters(parameter = false, possibleFilters) {
    let newFilters = Object.assign({}, this.state.currentFilters);
    let self = this;

    if (parameter) {
      newFilters = Object.assign(
        newFilters,
        this.selectAllInGroup(parameter, possibleFilters)
      );
    } else {
      Object.keys(possibleFilters).map(key => {
        newFilters = Object.assign(
          newFilters,
          self.selectAllInGroup(key, possibleFilters)
        );
      });
    }

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getProducts
    );
  }

  onFilterToggle(filterName, filterKey) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (typeof newFilters[filterName] !== "undefined") {
      const index = newFilters[filterName].indexOf(filterKey);
      if (index >= 0) {
        newFilters[filterName].splice(index, 1);
      } else {
        newFilters[filterName].push(filterKey);
      }
    } else {
      newFilters[filterName] = [filterKey];
    }
    this.setState(
      {
        currentFilters: newFilters
      },
      this.getProducts
    );
  }

  selectMultipleFilters(filterName, selections) {
    let newFilters = Object.assign({}, this.state.currentFilters);
    newFilters[filterName] = selections;

    this.setState(
      {
        currentFilters: newFilters
      },
      this.getProducts
    );
  }

  getService(key) {
    let service = "";

    Flagship.config.lineItemServices.map(function(element) {
      if (element.hasOwnProperty("subOptions")) {
        let innerFound = element.subOptions.find(function(subElement) {
          return subElement.value === key;
        });
        if (typeof innerFound !== "undefined") {
          service = element.text + " - " + innerFound.text;
        }
      }
      if (element.value === key) {
        service = element.text;
      }
    });
    return service;
  }

  setExpanded(filter, value) {
    if (filter && filter !== "default" && value === true) {
      this.setState({
        expandedFilters: filter
      });
    } else {
      this.setState({
        expandedFilters: false
      });
    }
  }

  saveData() {
    let filename = "IOProducts_" + moment().format("MM-DD-YYYY") + ".csv";

    const processRow = function(row) {
      let finalVal = "";
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        finalVal += result;
      }
      return finalVal + "\n";
    };

    let csvFile = "";

    csvFile += processRow(this.exportHeadings);

    for (let i = 0; i < this.state.exportData.length; i++) {
      csvFile += processRow(this.state.exportData[i]);
    }

    let blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  clean(results) {
    // Clean up results
    let data = [];

    results.map(item => {
      data.push([
        item.campaign_name,
        item.platform,
        "#" + item.io_product_key,
        item.io_product_name,
        item.io_product_type,
        item.market,
        item.record_name + " (#" + item.record_key + ")",
        item.assignee === "" || item.assignee === null
          ? "Unassigned"
          : item.first_name + " " + item.last_name,
      ]);
    });
    return data;
  }

  

  render() {
    let possibleFilters = {
      market: Flagship.config.markets,
      service: Flagship.config.lineItemServices,
      assignee: Flagship.config.userGroups
    };
    const displayBody = () => {

      if (this.state.loading) {
        return (
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="6">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else if (!this.state.campaigns || !this.state.campaigns.length) {
        return (
          <Table.Body>
            <Table.Row className="no-results">
              <Table.Cell colSpan="6">
                <Icon name="thumbs down" size="huge" />
                <h3>Nothing Found.</h3>
                <p>
                  Flagship did not find any campaigns that match the criteria
                  you've selected.
                </p>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else {
        return (
          <Table.Body>
            {typeof this.state.campaigns === "object" &&
            this.state.campaigns !== null
              ? this.state.campaigns.map(function(row, i) {
                  let productLink =
                    "/io/view/" +
                    row.io_key +
                    "/focus/" +
                    row.io_product_key;


                  return (
                    <Table.Row key={i}>
                      <Table.Cell key="campaign_name">
                        <Link to={productLink}>
                          <span style={{display:"inline-block"}}>{row.campaign_name}</span>
                        </Link>
                      </Table.Cell>
                       <Table.Cell key="platform">
                        <Link to={productLink}>
                          {row.platform}
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="name">
                        <Link to={productLink}>
                            <span>
                              {row.io_product_name}         
                              <em className="table-secondary">({row.io_product_key})</em>     
                            </span>                          
                        </Link>
                      </Table.Cell>

                      <Table.Cell key="client">
                        <Link to={"/client/view/" + row.client_key}>
                          {row.client_name}{" "}
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="market">
                        <Link to={productLink}>
                          <Label horizontal>{row.market}</Label>
                        </Link>
                      </Table.Cell>
                      <Table.Cell key="assignee">
                        <Link to={productLink}>
                          {row.user_id === null ? (
                            <span>
                              <em style={{ color: "#999" }}>(Unassigned)</em>
                            </span>
                          ) : (
                            row.first_name + " " + row.last_name
                          )}
                        </Link>
                      </Table.Cell>

                    </Table.Row>
                  );
                })
              : null}
          </Table.Body>
        );
      }
    };

    let currentFilters = this.state.currentFilters;
    let search = this.search;

    const hasActiveFilters = () => {
      if (Object.keys(currentFilters).length <= 1) {
        return false;
      }
      let returnVal = false;
      Object.keys(currentFilters).map(function(filter) {
        if (filter !== "instance" && currentFilters[filter].length > 0) {
          returnVal = true;
        }
      });
      return returnVal;
    };

    return (
      <div className="fade-in">
        <div id="view-header-section">
          <h1 className="view-title">Registered Campaigns</h1>

          <div className="view-filters">
            {this.state.filtersVisible === true || hasActiveFilters() ? (
              <Button
                onClick={this.toggleFiltersVisibility}
                color="pink"
                className="filter-data filtering-active"
              >
                <Icon name="filter" />
                Filtering Data
              </Button>
            ) : (
              <Button
                onClick={this.toggleFiltersVisibility}
                className="filter-data"
              >
                <Icon name="filter" />
                Filter Data...
              </Button>
            )}

           

            <Button as={Link} to="/io-products" className="view-switch">
              <Icon name="eye" />
              IO Products...
            </Button>
          </div>

          <div className="view-search">
            <Input
              placeholder={"Search " + this.props.route.niceName + "..."}
              onKeyUp={search}
            />
          </div>
        </div>

        {this.state.filtersVisible ? (
          <Modal open={true} closeIcon onClose={this.toggleFiltersVisibility}>
            <Filters
              active={currentFilters}
              possible={possibleFilters}
              expandedFilters={this.state.expandedFilters}
              parameters={{
                market: "Market",
                service: "Service",
                assignee: "Assignee"
              }}
              matches={this.state.totalCount}
              onToggle={this.onFilterToggle}
              onSelectNone={this.clearFilters}
              onSelectAll={parameter =>
                this.selectAllFilters(parameter, possibleFilters)
              }
              onSelectMultiple={(group, selections) =>
                this.selectMultipleFilters(group, selections)
              }
              setExpanded={(filter, value) => this.setExpanded(filter, value)}
            />
          </Modal>
        ) : null}

        

        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Campaign Name</Table.HeaderCell>
              <Table.HeaderCell>Platform</Table.HeaderCell>
              <Table.HeaderCell>IO Product</Table.HeaderCell>
              <Table.HeaderCell>Client</Table.HeaderCell>
              <Table.HeaderCell>Market</Table.HeaderCell>
              <Table.HeaderCell>Assignee</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {displayBody()}
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6" className="view-pagination">
                <Menu pagination>
                  {this.state.currentPage > 1 ? (
                    <Menu.Item icon onClick={this.prevPage}>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  )}

                  {this.state.currentPage > 3 ? (
                    <Menu.Item name="1" onClick={() => this.jumpToPage(1)} />
                  ) : null}

                  {this.state.currentPage > 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage > 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage > 1 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 1)
                      }
                    />
                  ) : null}

                  <Menu.Item
                    name={String(this.state.currentPage)}
                    active={true}
                    onClick={() => this.jumpToPage(this.state.currentPage)}
                  />

                  {this.state.currentPage < this.state.totalPages ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 1)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 2 &&
                  this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 3)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 3)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 1 &&
                  this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 4)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 4)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.totalPages)}
                      onClick={() => this.jumpToPage(this.state.totalPages)}
                    />
                  ) : null}

                  {this.state.currentPage !== this.state.totalPages ? (
                    <Menu.Item icon onClick={this.nextPage}>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  )}
                </Menu>
                <div className="total-records">
                  Found {this.state.totalCount}
                  {empty(this.state.currentFilters)
                    ? " total " + this.props.route.niceName + "."
                    : " " +
                      this.props.route.niceName +
                      " matching your search criteria."}
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>

        {this.state.choosingAssignee ? (
          <FilterAssigneeModal
            filterAssignee={(e, value) => {
              this.filterAssignee(e, value);
            }}
            chooseAssignee={value => {
              this.chooseAssignee(value);
            }}
          />
        ) : null}
      </div>
    );
  }
}

Campaigns.propTypes = {
  actions: PropTypes.object,
  token: PropTypes.string
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    instance: state.main.instance,
    userRole: state.main.userRole
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/components/views/Campaigns.js